// extracted by mini-css-extract-plugin
export default {"Topic":"Topic-styles__Topic__JJDe8","Topic__icon":"Topic-styles__Topic__icon__NHhsG","Topic__title":"Topic-styles__Topic__title__X5fk4"};